(ns bp-clients.tv-app.api.subs
  "Namespace for all api subscriptions"
  (:require [bp-clients.tv-app.api.events :as api-events]
            [re-frame.core :refer [reg-sub]]))

(defn api-sub
  [db]
  (get db ::api-events/api))

(defn api-loaded-sub
  "Given the app's state. Returns true if the app has finished loading."
  [{:keys [re-graph]}]
  (or
   (:auth re-graph)
   (:no-auth re-graph)))

(reg-sub ::api api-sub)
(reg-sub ::api-loaded? :<- [::api] api-loaded-sub)
